"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTimestampPair = normalizeTimestampPair;
exports.normalizeKeyPointTimestamps = normalizeKeyPointTimestamps;
const utils_1 = require("@repo/utils");
/*
 * Some legacy payloads emit `MM:SS:XX` (centiseconds in the last block)
 * instead of `HH:MM:SS`. Each keypoint also carries an authoritative
 * `totalDurationSeconds`, so whichever reading of the pair matches it wins.
 * Ported from the website (yt-analysis-content.tsx) so both surfaces seek to
 * the same second.
 */
const DURATION_TOLERANCE_SECONDS = 2;
const SHORT_CLIP_SECONDS = 300;
const shiftTimestampBlocks = (timestamp) => {
    if (!timestamp)
        return '00:00:00';
    const parts = timestamp.split(':');
    if (parts.length !== 3)
        return '00:00:00';
    const first = parts[0] ?? '00';
    const second = parts[1] ?? '00';
    return `00:${first.padStart(2, '0')}:${second.padStart(2, '0')}`;
};
function normalizeTimestampPair(startTimestamp, endTimestamp, totalDurationSeconds) {
    const startOriginal = (0, utils_1.timestampToSeconds)(startTimestamp);
    const endOriginal = (0, utils_1.timestampToSeconds)(endTimestamp);
    const startShifted = shiftTimestampBlocks(startTimestamp);
    const endShifted = shiftTimestampBlocks(endTimestamp);
    const startShiftedSeconds = (0, utils_1.timestampToSeconds)(startShifted);
    const endShiftedSeconds = (0, utils_1.timestampToSeconds)(endShifted);
    const matches = (duration) => Math.abs(duration - totalDurationSeconds) <= DURATION_TOLERANCE_SECONDS;
    if (matches(endOriginal - startOriginal)) {
        return {
            start: (0, utils_1.secondsToTimestamp)(startOriginal),
            end: (0, utils_1.secondsToTimestamp)(endOriginal),
        };
    }
    if (matches(endShiftedSeconds - startShiftedSeconds)) {
        return { start: startShifted, end: endShifted };
    }
    if (totalDurationSeconds < SHORT_CLIP_SECONDS) {
        return {
            start: startShifted,
            end: (0, utils_1.secondsToTimestamp)(startShiftedSeconds + totalDurationSeconds),
        };
    }
    return {
        start: startTimestamp,
        end: (0, utils_1.secondsToTimestamp)(startOriginal + totalDurationSeconds),
    };
}
function normalizeKeyPointTimestamps(keyPoints) {
    return keyPoints.map((keyPoint) => {
        const { start, end } = normalizeTimestampPair(keyPoint.startTimestamp, keyPoint.endTimestamp, keyPoint.totalDurationSeconds);
        return { ...keyPoint, startTimestamp: start, endTimestamp: end };
    });
}
